// src/services/organizationService.js
import api from './api';

export const organizationService = {
  // 공개: 슬러그로 조직 공개 정보 (테넌트 사이트용)
  getBySlugPublic: async (slug) => {
    const response = await api.get(`/organizations/by-slug/${slug}`);
    return response.data;
  },

  // 고객사 목록 조회 (플랫폼 관리자)
  getOrganizations: async (params = {}) => {
    const response = await api.get('/platform/organizations', { params });
    return response.data;
  },

  // 고객사 상세 조회
  getOrganization: async (orgId) => {
    const response = await api.get(`/platform/organizations/${orgId}`);
    return response.data;
  },

  // 고객사 생성
  createOrganization: async (data) => {
    const response = await api.post('/platform/organizations', data);
    return response.data;
  },

  // 고객사 수정
  updateOrganization: async (orgId, data) => {
    const response = await api.put(`/platform/organizations/${orgId}`, data);
    return response.data;
  },

  // 고객사 관리자 생성
  createOrgAdmin: async (orgId, data) => {
    const response = await api.post(`/platform/organizations/${orgId}/admins`, data);
    return response.data;
  },

  // 플랫폼 전체 통계
  getPlatformStats: async () => {
    const response = await api.get('/platform/stats');
    return response.data;
  },

  // PG 설정 조회
  getPaymentConfig: async (orgId) => {
    const response = await api.get(`/platform/organizations/${orgId}/payment`);
    return response.data;
  },

  // PG 설정 수정
  updatePaymentConfig: async (orgId, data) => {
    const response = await api.patch(`/platform/organizations/${orgId}/payment`, data);
    return response.data;
  },
};

export default organizationService;
